import { useEffect, useState } from 'react'
import BiometricAuthService from '../services/BiometricAuthService'

export default function useBiometricCapability() {
  const [state, setState] = useState({ available: false, type: null, loading: true })

  useEffect(() => {
    let cancelled = false

    async function detect() {
      try {
        const [{ available, type }, hasVault] = await Promise.all([
          BiometricAuthService.isAvailable(),
          BiometricAuthService.hasVault(),
        ])

        const canUnlock = available && hasVault
        if (!cancelled) {
          setState({ available: canUnlock, type: canUnlock ? type : null, loading: false })
        }
      } catch (e) {
        if (!cancelled) {
          setState({ available: false, type: null, loading: false })
        }
      }
    }

    detect()

    return () => {
      cancelled = true
    }
  }, [])

  return state
}
